<template>
  <div class="report-list-container">
    <el-card class="page-header-card" shadow="hover">
      <div class="page-header">
        <div class="page-title-section">
          <h2 class="page-title">
            <font-awesome-icon icon="chart-pie" class="page-title-icon" />
            Тайлан удирдах хэсэг
          </h2>
          <p class="page-subtitle">Тайлангуудыг үүсгэх, засах, устгах</p>
        </div>
        <el-button
          v-if="checkPermissionsPage('admin')"
          @click="createReportDialogOpen()"
          type="primary"
          size="large"
          class="create-button"
        >
          <font-awesome-icon icon="plus" class="button-icon" />
          Тайлан үүсгэх
        </el-button>
      </div>
    </el-card>

    <el-card class="table-card mt-10" shadow="hover">
      <template #header>
        <div class="table-header">
          <font-awesome-icon icon="table" class="table-header-icon" />
          <span class="table-header-title">Тайлангийн жагсаалт</span>
          <el-tag type="info" class="table-count-tag">{{ filteredData.length }} тайлан</el-tag>
        </div>
      </template>
      <!-- Search and Filter -->
      <div class="search-filter-section">
        <el-input
          v-model="searchQuery"
          placeholder="Тайлангийн нэрээр хайх..."
          class="search-input"
          clearable
        >
          <template #prefix>
            <font-awesome-icon icon="search" />
          </template>
        </el-input>
        <el-select
          v-model="statusFilter"
          placeholder="Төлөв"
          class="filter-select"
          clearable
        >
          <el-option label="Бүгд" value="" />
          <el-option label="Идэвхтэй" value="active" />
          <el-option label="Идэвхгүй" value="inactive" />
        </el-select>
      </div>
      <el-table
        :data="paginatedData"
        style="width: 100%"
        border
        class="modern-report-table"
        stripe
        @sort-change="handleSortChange"
      >
            <el-table-column label="Тайлангийн нэр" prop="name" sortable="custom"></el-table-column>
            <el-table-column label="Үүсгэсэн огноо" prop="createdAt" sortable="custom" width="180">
              <template #default="scope">
                {{ formatDate(scope.row.createdAt) }}
              </template>
            </el-table-column>
            <el-table-column label="Төлөв" prop="is_active" v-if="checkPermissionsPage('admin')">
              <template #default="scope">
                <el-switch @change="changeStatus(scope.row)" v-model="scope.row.is_active" class="ml-2" inline-prompt style="--el-switch-on-color: #13ce66; --el-switch-off-color: #ff4949" active-text="Идэвхтэй" inactive-text="Идэвхгүй" />
              </template>
            </el-table-column>
            <el-table-column label="Үйлдэл" width="350" v-if="checkPermissionsPage('admin')" align="center">
              <template v-slot="scope">
                <el-button-group>
                  <el-button
                    v-if="checkPermissionsPage('admin')"
                    @click="viewReport(scope.row)"
                    type="primary"
                    size="small"
                    class="action-button"
                  >
                    <font-awesome-icon icon="eye" class="button-icon-small" />
                    Харах
                  </el-button>
                  <el-button
                    v-if="checkPermissionsPage('admin')"
                    @click="duplicateReport(scope.row)"
                    size="small"
                    class="action-button"
                    type="info"
                  >
                    <font-awesome-icon icon="copy" class="button-icon-small" />
                    Хуулбарлах
                  </el-button>
                  <el-button
                    v-if="checkPermissionsPage('admin')"
                    @click="createReportDialogOpen(scope.row)"
                    size="small"
                    class="action-button"
                  >
                    <font-awesome-icon icon="edit" class="button-icon-small" />
                    Засварлах
                  </el-button>
                  <el-button
                    v-if="checkPermissionsPage('admin')"
                    @click="deleteRow(scope.row)"
                    type="danger"
                    size="small"
                    class="action-button"
                  >
                    <font-awesome-icon icon="trash" class="button-icon-small" />
                    Устгах
                  </el-button>
                </el-button-group>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @current-change="handlePageChange"
            :current-page="currentPage"
            :page-size="pageSize"
            :total="filteredData.length"
            layout="total, prev, pager, next, jumper"
            class="modern-pagination" />
    </el-card>
    <CreateReportDialog :selectedReport="this.targetReport" @reload="loadData" />
  </div>
</template>
<script>
import services from '@/services'
import { ElMessage, ElMessageBox } from 'element-plus'
import { mapActions, mapGetters } from 'vuex'
import CreateReportDialog from './createReportDialog.vue'
import { checkPermissions } from '@/helpers/custom'

export default {
  name: 'ReportListPage',
  components: {
    CreateReportDialog
  },
  created () {
    this.loadData()
  },
  data () {
    return {
      currentPage: 1,
      pageSize: 10,
      data: [],
      targetReport: {},
      searchQuery: '',
      statusFilter: '',
      sortColumn: null,
      sortOrder: null
    }
  },
  computed: {
    ...mapGetters([
      'cdnGetter'
    ]),
    filteredData () {
      let result = [...this.data]

      // Search filter
      if (this.searchQuery) {
        const query = this.searchQuery.toLowerCase()
        result = result.filter(item =>
          item.name && item.name.toLowerCase().includes(query)
        )
      }

      // Status filter
      if (this.statusFilter === 'active') {
        result = result.filter(item => item.is_active === true)
      } else if (this.statusFilter === 'inactive') {
        result = result.filter(item => item.is_active === false)
      }

      // Sorting
      if (this.sortColumn) {
        result.sort((a, b) => {
          const aVal = a[this.sortColumn]
          const bVal = b[this.sortColumn]

          if (aVal === bVal) return 0

          const comparison = aVal > bVal ? 1 : -1
          return this.sortOrder === 'ascending' ? comparison : -comparison
        })
      }

      return result
    },
    paginatedData () {
      const startIndex = (this.currentPage - 1) * this.pageSize
      return this.filteredData.slice(startIndex, startIndex + this.pageSize)
    }
  },
  methods: {
    ...mapActions(['setCreateReportDialog']),
    async loadData () {
      try {
        // Бүх тайланг (идэвхтэй болон идэвхгүй) авах
        const response = await services.get('reports', { include_inactive: 'true' })
        if (response && response.type === 'success') {
          this.data = response.data
        } else {
          ElMessage.error('Өгөгдөл олдсонгүй!')
        }
      } catch (error) {
        console.error('Error fetching data: ', error)
        ElMessage.error(`Өгөгдөл ачаалахад алдаа гарлаа: ${error.message}`)
      }
    },
    checkPermissionsPage (data) {
      return checkPermissions(data)
    },
    handlePageChange (page) {
      this.currentPage = page
    },
    handleSortChange ({ column, prop, order }) {
      this.sortColumn = prop
      this.sortOrder = order
      this.currentPage = 1
    },
    viewReport (row) {
      this.$router.push(`/reports/${row.id}`)
    },
    createReportDialogOpen (data) {
      this.targetReport = data || {}
      this.setCreateReportDialog(true)
    },
    async deleteRow (row) {
      try {
        await ElMessageBox.confirm('Та энэ тайланг устгахдаа итгэлтэй байна уу?', 'Баталгаажуулалт', {
          confirmButtonText: 'Тийм',
          cancelButtonText: 'Үгүй',
          type: 'warning'
        })
        await services.delete('reports', row.id)
        this.loadData()
        ElMessage.success('Амжилттай устгагдлаа!')
      } catch (error) {
        if (error !== 'cancel') {
          ElMessage.error('Устгахад алдаа гарлаа!')
        }
      }
    },
    async changeStatus (data) {
      try {
        const response = await services.update('reports', data)
        if (response && response.data) {
          ElMessage.success('Төлөв амжилттай өөрчлөгдлөө!')
        }
      } catch (error) {
        console.error('Aldaa: ', error.message)
        ElMessage.error(error.message)
      }
    },
    async duplicateReport (row) {
      try {
        const newReport = {
          name: `${row.name} (Хуулбар)`,
          query: row.query,
          is_active: false
        }
        const response = await services.create('reports', newReport)
        if (response && response.type === 'success') {
          ElMessage.success('Тайлан амжилттай хуулбарлагдлаа!')
          this.loadData()
        }
      } catch (error) {
        console.error('Error duplicating report:', error)
        ElMessage.error('Тайлан хуулбарлахад алдаа гарлаа!')
      }
    },
    formatDate (dateString) {
      if (!dateString) return '-'
      const date = new Date(dateString)
      return date.toLocaleDateString('mn-MN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      })
    }
  }
}
</script>
<style lang="scss" scoped>
/* Report List Container */
.report-list-container {
  padding: 0;
}

/* Page Header Card */
.page-header-card {
  border-radius: 16px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  border: none;
  margin-bottom: 24px;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
}

.page-title-section {
  flex: 1;
}

.page-title {
  font-size: 28px;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 8px 0;
  display: flex;
  align-items: center;
  gap: 12px;
}

.page-title-icon {
  color: #667eea;
  font-size: 32px;
}

.page-subtitle {
  font-size: 14px;
  color: #6b7280;
  margin: 0;
}

.create-button {
  border-radius: 8px;
  padding: 12px 24px;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
  transition: all 0.3s ease;
}

.create-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(102, 126, 234, 0.4);
}

.button-icon {
  margin-right: 8px;
}

/* Table Card */
.table-card {
  border-radius: 16px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  border: none;
}

.table-header {
  display: flex;
  align-items: center;
  gap: 12px;
}

.table-header-icon {
  color: #667eea;
  font-size: 20px;
}

.table-header-title {
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
  flex: 1;
}

.table-count-tag {
  border-radius: 20px;
  padding: 4px 12px;
}

/* Modern Report Table */
.modern-report-table {
  border-radius: 8px;
  overflow: hidden;
}

.modern-report-table :deep(.el-table__header) {
  background: #f9fafb;
}

.modern-report-table :deep(.el-table__header th) {
  background: #f9fafb;
  color: #374151;
  font-weight: 600;
  border-bottom: 2px solid #e5e7eb;
  padding: 16px 0;
}

.modern-report-table :deep(.el-table__body tr:hover) {
  background: #f3f4f6;
}

.modern-report-table :deep(.el-table__body td) {
  padding: 16px 0;
}

/* Action Buttons */
.action-button {
  border-radius: 6px;
  transition: all 0.2s ease;
}

.action-button:hover {
  transform: translateY(-1px);
}

.button-icon-small {
  margin-right: 4px;
  font-size: 12px;
}

/* Pagination */
.modern-pagination {
  margin-top: 24px;
  display: flex;
  justify-content: flex-end;
}

/* Search and Filter Section */
.search-filter-section {
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}

.search-input {
  flex: 1;
  min-width: 200px;
}

.filter-select {
  width: 150px;
}

/* Responsive */
@media (max-width: 768px) {
  .page-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .page-title {
    font-size: 24px;
  }

  .action-button {
    margin-bottom: 4px;
    font-size: 11px;
    padding: 6px 8px;
  }

  .button-icon-small {
    display: none;
  }

  /* Mobile Table Scroll */
  .table-card {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .modern-report-table {
    min-width: 600px;
  }
}

@media (max-width: 480px) {
  .page-title {
    font-size: 20px;
  }

  .create-button {
    width: 100%;
    margin-top: 8px;
  }
}
</style>
